module.exports = __webpack_public_path__ + "img/3.b572dac9.jpg";